module.exports = __webpack_public_path__ + "assets/img/11_739_big.d8437ac9.jpg";